export const RepairabilityDocsOrder = 'A107,A103,A104,A105,A106';
